import { XCircle } from 'lucide-react'

type ChipProps = {
  name: string
  colour: string
  icon?: string | React.ReactNode
  onRemove?: () => void
}

export const Chip = ({ name, icon, colour, onRemove }: ChipProps) => {
  return (
    <span
      className="px-2 rounded-md border flex items-center w-fit h-6"
      style={{
        color: colour,
        borderColor: colour,
        backgroundColor: `color-mix(in srgb, ${colour} 20%, transparent)`,
      }}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {name}
      {onRemove && (
        <button
          className="cursor-pointer ml-2 transition-opacity duration-200 hover:opacity-50"
          onClick={onRemove}
        >
          <XCircle className="size-4" />
        </button>
      )}
    </span>
  )
}

export default Chip
